/**
 * created by tian ruo jun
 编辑器流程等按钮页面
 *
 */
import React from 'react';
import IconFont from "../../../components/svgIcon/IconFont";
import ActivitiModal from "./ActivitiModal";
import svgList from "../image/svgList";
import {Icon} from "antd";

const ActivityBtn = ({activityOption}) => {
    return (
        <>
            <ActivitiModal
                // ref={(ref)=>{this.ActivitiModal=ref}}
                {
                    ...activityOption
                }
            />
        </>
    )
};

const OtherBtn = ({showReason,showDiscardReasonCall,showCoordinationBtn,coordinationCall,showPickup,savePickup,showAgain,saveStory,saveAgain,showDiscard,saveDiscard, showSave, showPreview, showPrint, previewCall, printCall,showRemarksCall,showRemarks,showPublishMediaListModalBtn,showPublishMediaListModalBtnCall,undoCall,showUndo}) => {
    return (
        <>
            {showPickup?<div className={'btnStyle'} onClick={()=>{savePickup(null)}}>
                <IconFont className={'btnIcon'} type={svgList("rmt_shiqu")} style={{}}/>
                <span>拾取至</span>
            </div>:null}
            {showAgain?<div className={'btnStyle'} onClick={()=>{saveAgain(null)}}>
                <IconFont className={'btnIcon'} type={svgList("rmt_zhongxinshiqu")} style={{}}/>
                <span>重新采用</span>
            </div>:null}
            {showDiscard?<div className={'btnStyle'} onClick={()=>{saveDiscard(null)}}>
                <IconFont className={'btnIcon'} type={svgList("act_deserted")} style={{}}/>
                <span>弃用</span>
            </div>:null}
            {showSave?<div className={'btnStyle'} onClick={()=>{saveStory(null)}}>
                <IconFont className={'btnIcon'} type={svgList("save")} style={{}}/>
                <span>暂存</span>
            </div>:null}
            {showPreview?<div className={'btnStyle'} onClick={previewCall}>
                <IconFont className={'btnIcon'} type={svgList("preview")} style={{}}/>
                <span>预览</span>
            </div>:null}
            {showPrint?<div className={'btnStyle'} onClick={printCall}>
                <IconFont className={'btnIcon'} type={svgList("print")} style={{}}/>
                <span>打印</span>
            </div>:null}
            {showRemarks?<div className={'btnStyle'} onClick={showRemarksCall}>
                <IconFont className={'btnIcon'} type={svgList("remarks")} style={{}}/>
                <span>查看备注</span>
            </div>:null}
            {showReason?<div className={'btnStyle'} onClick={showDiscardReasonCall}>
                <IconFont className={'btnIcon'} type={svgList("remarks")} style={{}}/>
                <span>查看原因</span>
            </div>:null}
            {showPublishMediaListModalBtn?<div className={'btnStyle'} onClick={showPublishMediaListModalBtnCall}>
                <IconFont className={'btnIcon'} type={svgList("remarks")} style={{}}/>
                <span>访问</span>
            </div>:null}
            {showCoordinationBtn?<div className={'btnStyle'} onClick={coordinationCall}>
                <IconFont className={'btnIcon'} type={svgList("save")} style={{}}/>
                <span>保存为协同稿件</span>
            </div>:null}
            {/*<div style={{color:'#fff'}} onClick={() => this.setContent(this.state.content)}>设置内容</div>*/}
            {/*<div style={{color:'#fff'}} onClick={() => this.setCurrentInformation()}>设置信息</div>*/}
       
            {showUndo ? <div className={'btnStyle'} onClick={undoCall}>
               <IconFont className={'btnIcon'} type={svgList("act_goback")} style={{}} />
               <span>撤稿</span>
           </div> : null}
        </>
    )
};

const ButtonList = ({showReason,showDiscardReasonCall,showDiscardReason,coordinationCall,showCoordinationBtn,topBtnHeight, activityOption,savePickup,showPickup,showAgain,saveAgain,showDiscard,saveDiscard,saveStory, showSave, showPreview, showPrint, previewCall, printCall,showRemarksCall,showRemarks,showPublishMediaListModalBtn,showPublishMediaListModalBtnCall,isLockedData={},undoCall, showUndo}) => {
    return (
        <div
            id={'btnList'}
            className={'flexCenter'}
            style={{height: topBtnHeight, background: window.themeBgColor, padding: '0 20px', color: '#fff'}}
        >
            {
                isLockedData && isLockedData.status === false ?
                    <div style={{
                        color: 'rgb(253, 109, 106)',
                        verticalAlign: "middle"
                    }}><Icon type="info-circle"/>&nbsp;当前稿件“{isLockedData.LockUserName}”正在编辑，您只能预览，不能编辑</div>
                    :
                    <>
                        <ActivityBtn activityOption={activityOption}/>
                        <OtherBtn
                            saveStory={saveStory}
                            showSave={showSave}
                            showPreview={showPreview}
                            showPrint={showPrint}
                            previewCall={previewCall}
                            printCall={printCall}
                            showRemarks={showRemarks}
                            showRemarksCall={showRemarksCall}
                            showPublishMediaListModalBtn={showPublishMediaListModalBtn}
                            showPublishMediaListModalBtnCall={showPublishMediaListModalBtnCall}
                            savePickup={savePickup}
                            showPickup={showPickup}
                            showAgain={showAgain}
                            saveAgain={saveAgain}
                            showDiscard={showDiscard}
                            saveDiscard={saveDiscard}
                            coordinationCall={coordinationCall}
                            showCoordinationBtn={showCoordinationBtn}
                            undoCall={undoCall}
                            showUndo={showUndo}
                            showReason={showReason}
                            showDiscardReasonCall={showDiscardReasonCall}
                        />
                    </>
            }
        </div>
    )
};

export default ButtonList
